<div class="organisation">
  <ng-container *ngIf="data">
    <div class="organisation__header">
      <div class="organisation__logo">
        <app-photo
          [type]="'photo'"
          [id]="data.photoId"
          [text]="data.shortName"
          [size]="'xxl'"
          [rounded]="true"
          [loading]="loading"
        ></app-photo>
      </div>

      <div class="organisation__text-box">
        <h3 class="organisation__title" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
          {{ data.shortName }}
        </h3>

        <p class="organisation__subtitle" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
          {{ data.businessTypesComplected }}
        </p>
      </div>
    </div>

    <div class="organisation__list">
      <app-navigation-list
        *ngIf="!loading"
        [navTree]="navTree"
        [mode]="isLargeScreen ? 'desktop' : 'tab'"
      ></app-navigation-list>
    </div>

    <tui-scrollbar *ngIf="organisationId && !loading" class="organisation__content">
      <!-- Информация -->
      <app-organisation-info
        *ngIf="selectedItem?.id === ASSOCIATION_MENU_ITEM.Info && isMenuItemVisible(selectedItem?.id)"
        mode="view"
        [organisationId]="organisationId"
        (deleted)="deleted.emit($event)"
        (saved)="saved.emit()"
      ></app-organisation-info>

      <!-- Сотрудники -->
      <app-organisation-personal
        *ngIf="selectedItem?.id === ASSOCIATION_MENU_ITEM.Users && isMenuItemVisible(selectedItem?.id)"
        [organisationId]="organisationId"
        [selectedUserId]="menuObjectId"
        [title]="getMenuItemTitle(ASSOCIATION_MENU_ITEM.Users)"
        (selectedUserIdChange)="onChangeMenuObjectId($event)"
      ></app-organisation-personal>

      <!-- Групповые чаты -->
      <app-base-chats-list
        *ngIf="
          selectedItem?.id === ASSOCIATION_MENU_ITEM.Channels && isMenuItemVisible(selectedItem?.id) && organisationId
        "
        [title]="getMenuItemTitle(ASSOCIATION_MENU_ITEM.Channels)"
        [attachObject]="{ id: organisationId, name: 'organisation' }"
        [permissions]="{
          allowGroupChatCreating: (permissionService.allowChatsCreating$ | async),
        }"
      ></app-base-chats-list>

      <!-- Комитеты -->
      <app-organisation-committees
        *ngIf="selectedItem?.id === ASSOCIATION_MENU_ITEM.Committees && isMenuItemVisible(selectedItem?.id)"
        [organisationId]="organisationId"
      ></app-organisation-committees>

      <!-- Настройки -->
      <app-organisation-configs
        *ngIf="selectedItem?.id === ASSOCIATION_MENU_ITEM.Configs && isMenuItemVisible(selectedItem?.id)"
        [organisationId]="organisationId"
      ></app-organisation-configs>
    </tui-scrollbar>
  </ng-container>
</div>
